import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { Button, CardContent, Typography } from '@guildeducationinc/recess';
import KeyboardArrowDownIcon from '@guildeducationinc/recess/icons/KeyboardArrowDownIcon';
import KeyboardArrowUpIcon from '@guildeducationinc/recess/icons/KeyboardArrowUpIcon';
import { InfoPopover, useLocale } from 'pe-core-frontend';
import styles from './FundingOverviewSummary.module.scss';
export const FundingOverviewSummary = React.memo(({ fundingSummary, selectedPeriod, isBreakdownExpanded, onToggleBreakdown }) => {
    const { formatCurrency, t } = useLocale();
    const { labelText, formattedAmountText, infoPopoverContent } = useMemo(() => {
        const currency = fundingSummary?.currency || '$';
        const isUnlimited = fundingSummary?.isUnlimited && selectedPeriod !== 'ALLTIME';
        const limitNumber = selectedPeriod === 'ALLTIME'
            ? Number(fundingSummary?.lifetimeCap || 0)
            : Number(fundingSummary?.currentYearCap || 0);
        if (selectedPeriod === 'ALLTIME') {
            const label = t('Lifetime funding limit:');
            const formatted = formatCurrency(limitNumber, currency, true);
            const popoverText = t('Your lifetime education benefit limit is {amount} across all categories.', { values: { amount: formatted } });
            return {
                labelText: label,
                formattedAmountText: formatted,
                infoPopoverContent: popoverText,
            };
        }
        // Handle unlimited funding for current period
        if (isUnlimited) {
            return {
                labelText: t('Benefit period funding limit:'),
                formattedAmountText: 'Unlimited',
                infoPopoverContent: 'Your employer provides unlimited funding for this benefit period across all categories.',
            };
        }
        const formatted = formatCurrency(limitNumber, currency, true, true);
        const popoverText = t('Your annual education benefit limit is {amount} across all categories.', { values: { amount: `${currency} ${limitNumber.toLocaleString()}` } });
        return {
            labelText: t('Benefit period funding limit:'),
            formattedAmountText: formatted,
            infoPopoverContent: popoverText,
        };
    }, [
        fundingSummary?.currency,
        selectedPeriod,
        fundingSummary?.lifetimeCap,
        fundingSummary?.currentYearCap,
        fundingSummary?.isUnlimited,
        formatCurrency,
        t,
    ]);
    return (_jsxs(CardContent, { className: styles.overviewContent, children: [_jsxs("div", { children: [_jsxs("div", { className: styles.fundingLimitText, children: [_jsxs(Typography, { variant: 'body1', children: [labelText, " ", _jsx("strong", { children: formattedAmountText })] }), _jsx(InfoPopover, { content: infoPopoverContent })] }), fundingSummary?.hasMultipleFundingPolicies && (_jsx(Typography, { variant: 'label2', className: styles.currencyDisclaimer, children: t('Certain categories have different funding limits.') }))] }), _jsx(Button, { appearance: 'ghost', iconDirection: 'right', icon: isBreakdownExpanded ? (_jsx(KeyboardArrowUpIcon, { size: 24 })) : (_jsx(KeyboardArrowDownIcon, { size: 24 })), onClick: onToggleBreakdown, className: styles.breakdownButton, children: _jsx(Typography, { variant: 'label2', className: styles.breakdownButtonText, children: isBreakdownExpanded ? t('Hide breakdown') : t('Show breakdown') }) })] }));
});
FundingOverviewSummary.displayName = 'FundingOverviewSummary';
